// [Gabriel] Naming del fichero
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { canActivateCategoryPage } from './guards/category-page.can-activate';
import { CategoryPageResolver } from './guards/category-resolver.guard';
import { CategoryLayoutComponent } from './layouts/category-layout.component';

const routes: Routes = [
    {
        path: '',
        resolve: [CategoryPageResolver],
        canActivate: [canActivateCategoryPage],
        component: CategoryLayoutComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CategoryPageRoutingModule {}
